import React from 'react';
import { Table, Button, Row, notification } from 'antd';
import { useNavigate } from 'react-router-dom';
import { generateFollowUpInvoice } from '@app/api/follow-up.api';

interface Invoice {
  id: number;
  invoice_number: string;
  total: string;
  status: string;
  created_at: string;
}

interface PaymentsInfoProps {
  id: string | null;
  pr_code: string | null;
  invoice_data: Invoice[];
  invoiceType?: string | null;
  fu_status?: string | null;
}

const PaymentsInfo: React.FC<PaymentsInfoProps> = ({ id, pr_code, invoice_data, fu_status }) => {
  const navigate = useNavigate();
  const showInvoice = (invoiceId: number, status: string, invoice_number: string, total: string) => {
    if (id !== null) {
      localStorage.setItem('invoiceType', 'FU');
      navigate(`/view-invoice`, {
        state: { id, pr_code, invoiceId, status, invoice_number, fu_status, total },
      });
    } else {
      notification.error({ message: 'Error', description: 'Invalid ID or Invoice' });
    }
  };

  const handleGenerateInvoice = async () => {
    try {
      if (!id) {
        notification.error({ message: 'Error', description: 'Invalid ID' });
        return;
      }

      // call API
      await generateFollowUpInvoice(Number(id), 'FU');

      notification.success({
        message: 'Success',
        description: 'Invoice generated successfully',
      });

      // optional: refresh or navigate
      // you can either refetch invoice list or redirect
      navigate(`/view-follow-up`, {
        state: { id },
      });
    } catch (error) {
      console.error(error);
      notification.error({
        message: 'Error',
        description: 'Failed to generate invoice',
      });
    }
  };

  const invoiceColumns = [
    {
      title: 'Invoice Number',
      dataIndex: 'invoice_number',
      key: 'invoice_number',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status: string) => <span style={{ color: status === 'PAID' ? 'green' : 'red' }}>{status}</span>,
    },
    {
      title: 'Total (LKR)',
      dataIndex: 'total',
      key: 'total',
    },
    {
      title: 'Action',
      key: 'action',
      render: (record: Invoice) => (
        <Row align="middle">
          <Button
            size="small"
            type="primary"
            onClick={() => showInvoice(record.id, record.status, record.invoice_number, record.total)}
          >
            View
          </Button>
        </Row>
      ),
    },
  ];

  const hasInvoices = invoice_data && invoice_data.length > 0;

  return (
    <>
      <h3>Invoices</h3>

      {hasInvoices ? (
        <Table dataSource={invoice_data} columns={invoiceColumns} rowKey="id" />
      ) : (
        <Row justify="center" style={{ margin: '20px 0' }}>
          <Button type="primary" onClick={handleGenerateInvoice}>
            Generate Invoice
          </Button>
        </Row>
      )}

      <h3>Receipts</h3>
      <p>No receipts available yet.</p>
    </>
  );
};

export default PaymentsInfo;
